module.exports = __webpack_public_path__ + "img/187.cd623a4c.jpg";